import { createLateCancelsService } from '@shared/api/late-cancels.service'
import { authorizedHttpClient } from './http-client'

export const LateCancelsService = createLateCancelsService(authorizedHttpClient, import.meta.env.VITE_API_URL)
